require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'SARA';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => import(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .mixin({ methods: { route } });
        
        app.config.globalProperties.$filters = {
            currency(value) {
                return new Intl.NumberFormat('es-AR', {
                   // style: 'currency',
                   // currency: 'ARS',
                    minimumFractionDigits: 2
                }).format(value)
            },
            // Put the rest of your filters here
        }
        app.mount(el);

    },
});

InertiaProgress.init({ color: '#4B5563', showSpinner: true });
